module.exports = __webpack_public_path__ + "static/media/medalla-oficial-santa-reliquia-virgen-coromoto.188bd0c8.jpg";